import React, { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import OTPInput from 'otp-input-react' // OTP input component
import CustomBtn from '../widgets/CustomBtn' // Custom button component

import logoImg from '../../assets/images/lociLogo.png'
import { verifyOTP, resendOTP } from '../_slice/onboardingSlice' // Redux action to verify OTP
import AppContext from '../context/AppContext' // Context for global state

/**
 * OtpVerification component for OTP verification
 */
function OtpVerification() {
  // Local state for OTP and error handling
  const [OTP, setOTP] = useState('')
  const [errorOtp, setErrorOtp] = useState(false)

  // React Router hooks for navigation and location state
  const location = useLocation()
  const navigate = useNavigate()

  // Redux dispatch hook for dispatching actions
  const dispatch = useDispatch()

  // AppContext to use global loader state
  const { setLoader } = useContext(AppContext)

  const resendOtp = () => {
    const url = location?.state?.type === 'signup' ? 'admin/auth/resend/otp' : 'admin/auth/password/forgot';
    // Dispatch verifyOTP action with necessary data
    dispatch(
      resendOTP({
        initialPost: {
          email: location?.state?.email // Email from location state
        },
        url, // Dynamic URL based on condition
        navigate,
        state: { email: location?.state?.email, type: location?.state?.type === 'signup' ? 'signup' : 'forgot' }, // State to pass with navigation
        setLoader
      })
    )
  }

  /**
   * Handle form submission.
   * Dispatches the verifyOTP action and navigates to reset-password on success.
   * @param {Object} e - Form event object.
   */
  const onSubmit = e => {
    e.preventDefault()

    // Check if OTP is undefined or empty, set error state if true
    if (OTP === undefined || OTP.length === 0) {
      setErrorOtp(true)
      return
    }

    const url = location?.state?.type === 'signup' ? 'admin/auth/verification' : 'admin/auth/password/token/verify';
    // Dispatch verifyOTP action with necessary data
    dispatch(
      verifyOTP({
        initialPost: {
          email: location?.state?.email, // Email from location state
          token: OTP // OTP entered by user
        },
        url, // Dynamic URL based on condition
        navigate,
        navigatePath: location?.state?.type === 'signup' ? '/organization' : '/reset-password', // Path to navigate on success
        state: { email: location?.state?.email, otp: OTP }, // State to pass with navigation
        setLoader
      })
    )
  }

  /**
   * Handle changes in the OTP input.
   * Updates the OTP state and error state based on input length.
   * @param {string} otpValue - The value of the OTP input.
   */
  const handleOtpChange = otpValue => {
    setOTP(otpValue)

    // Set error state based on OTP input length
    if (otpValue.length <= 0) {
      setErrorOtp(true)
    } else {
      setErrorOtp(false)
    }
  }

  return (
    <form onSubmit={onSubmit}>
      <div className='onboarding-box'>
        <div className='onboarding-box-header'>
          <img src={logoImg} alt='Loci Logo' className='onboarding-box-header-img' />
          <p className='onboarding-box-header-text'>The Evolution of Safety.</p>
        </div>
        <h2 className='onboardHeading mb-5'>VERIFY ONE TIME PASSWORD</h2>
        {/* OTP input field */}
        <div className='mb-4 position-relative'>
          {/* OTPInput component */}
          <OTPInput
            value={OTP}
            onChange={handleOtpChange}
            autoFocus
            OTPLength={6}
            otpType='number'
            disabled={false}
            inputClassName='otp_input'
            placeholder='000000'
          />

          {/* Label for OTP input */}
          <label className='custom_label'>One Time Password</label>
          {/* Error message */}
          {errorOtp && <p className='text-danger mt-3'>One Time Password required</p>}

          <button type='button' className='forgotPassword bg-transparent' onClick={resendOtp}>Resend One Time Password</button>
        </div>

        {/* Footer section */}
        <div className='onboarding-box-footer'>
          <CustomBtn buttonText='Next' type='submit' id='otpbtn' />
        </div>
      </div>
    </form>
  )
}

export default OtpVerification